import { OnInit, Component, inject } from "@angular/core";
import {
    DefinitionKey,
    SharedDefinitions
} from "@mrdm-self-service-frontend/shared/data-access-definitions";
import { Observable } from "rxjs";
import { BaseComponent } from "./base.component";

@Component({
    template: "",
    standalone: false
})
export abstract class BaseWithDefinitionsComponent extends BaseComponent implements OnInit {
    _definitions = inject(SharedDefinitions);

    public _initialized = false;

    protected abstract _getRequiredDefinitions(): DefinitionKey[];
    protected abstract _activate(): void;

    ngOnInit(): void {
        this._prepare().subscribe({
            complete: () => {
                this._initialized = true;
                this._activate();
            }
        });
    }

    protected _prepare(): Observable<void | any[]> {
        return this._definitions.load(...this._getRequiredDefinitions());
    }
}
